export default __webpack_public_path__ + "b6ead93763b59989f2a1e194f6eeb256.png";